<template>
  <div class="pg_code">
      <div class="code_frame"></div>
      <div class="close" @click="close"></div>
      <p class="code">礼包码：{{code}}</p>
      <div class="copy_wrapper">
        <div class="copy" :data-clipboard-text="code">复 制</div>
      </div>
  </div>
</template>
<script>
import * as types from '~/store/mutation-type';
import store from '~/store/index';

export default {
    props: ['code'],
    mounted() {
      let clipboard = new this.clipboard(".copy");
      clipboard.on('success', function () {
        store.commit(types.SHOW_ALERT, {msg: '复制成功~', type: 'msg'})
      });
      clipboard.on('error', function () {
        store.commit(types.SHOW_ALERT, {msg: '复制失败'});
      });
    },
    methods: {
      close() {
        this.$emit('close');
      },
    }
  }
</script>
<style rel="stylesheet/stylus" lang="stylus" scoped>
  .pg_code
    width: 7.5rem;
    height: 6.33rem;
    left: 0;
    position absolute
    top 50%
    margin-top -3.24rem
    .code_frame
      position: absolute;
      width: 7.5rem;
      height: 5.89rem;
      left: 0;
      bottom: 0
      background-image url('./images/code.png')
      background-size 100% 100%
    .code
      position: absolute;
      height: auto;
      font-size: 0.30rem;
      line-height: 1;
      color: #ad0b0b;
      left: 1.54rem;
      top: 1.83rem;
    .copy_wrapper
      position: absolute;
      width: 1.03rem;
      height: .41rem;
      left: 4.97rem;
      top: 1.76rem;
      border-style: solid;
      border-width: 0.01rem;
      border-color: rgb(148, 120, 77);
      padding 0.01rem
      .copy
        width 100%
        height 100%
        background-color: rgb(148, 120, 77);
        font-size: 0.26rem;
        line-height 0.36rem;
        text-align center
        color: rgb(255, 255, 255);

    .close
      position absolute
      width 0.73rem;
      height 0.73rem;
      background-image url('../images/close.png')
      background-size 100% 100%
      top 0;
      right 0.21rem;
</style>
